export default function Reviews() {
  const reviews = [
    {
      name: 'María González',
      rating: 5,
      comment: 'Excelente atención profesional. El Dr. Corral es muy dedicado y siempre está atento a cada detalle. Muy recomendable.',
      date: 'Hace 2 semanas'
    },
    {
      name: 'Carlos Martínez',
      rating: 5,
      comment: 'Muy buena experiencia. El personal es amable y los profesionales son muy competentes. Las instalaciones están impecables.',
      date: 'Hace 1 mes'
    },
    {
      name: 'Laura Fernández',
      rating: 4,
      comment: 'Atención de calidad y profesionales muy capacitados. Los tiempos de espera son razonables y el trato es excelente.',
      date: 'Hace 3 semanas'
    },
    {
      name: 'Roberto Silva',
      rating: 5,
      comment: 'Hace años que me atiendo aquí y siempre recibo la mejor atención. Profesionales de primera y muy buen seguimiento.',
      date: 'Hace 2 meses'
    },
    {
      name: 'Ana Rodríguez',
      rating: 5,
      comment: 'La Dra. Sayanes es excelente profesional. Me sentí muy bien atendida y contenida durante todo el tratamiento.',
      date: 'Hace 1 mes'
    },
    {
      name: 'Jorge López',
      rating: 4,
      comment: 'Muy conforme con la atención recibida. El instituto cuenta con buenos profesionales y equipamiento moderno.',
      date: 'Hace 3 semanas'
    }
  ];

  const renderStars = (rating: number) => {
    return (
      <div className="flex gap-1">
        {[...Array(5)].map((_, index) => (
          <i 
            key={index}
            className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-400 text-base`}
          ></i>
        ))}
      </div>
    );
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Opiniones de Nuestros Pacientes
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
          
          <div className="inline-flex items-center gap-3 bg-blue-50 rounded-full px-6 py-3">
            <div className="flex items-center gap-2">
              <i className="ri-google-fill text-2xl text-blue-600"></i>
              <span className="text-2xl font-bold text-gray-900">4.5</span>
            </div>
            <div className="flex gap-1">
              {[...Array(5)].map((_, index) => (
                <i 
                  key={index}
                  className={`ri-star-${index < 4 ? 'fill' : index === 4 ? 'half-fill' : 'line'} text-yellow-400 text-xl`}
                ></i>
              ))}
            </div>
            <span className="text-sm text-gray-600">30 opiniones</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-lg font-bold text-blue-600">
                      {review.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900">{review.name}</h4>
                    <p className="text-xs text-gray-500">{review.date}</p>
                  </div>
                </div>
              </div>
              
              <div className="mb-3">
                {renderStars(review.rating)}
              </div>
              
              <p className="text-sm text-gray-700 leading-relaxed">
                {review.comment}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="https://www.google.com/search?q=ICM+Instituto+de+Clinica+Medica+Mar+del+Plata" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold text-sm cursor-pointer whitespace-nowrap"
          >
            Ver todas las opiniones en Google
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}